import React from 'react';
import { Flex, LayoutBoxProps } from 'src/kit';
import FormikSlider, { FormikSliderProps } from './FormikSlider';
import { FormikInput, FormikInputProps } from './FormikInput';

export type FormikSliderFieldSetProps = LayoutBoxProps & {
  sliderProps?: FormikSliderProps;
  inputProps?: FormikInputProps;
};

const FormikSliderFieldSet = ({ name, inputProps, sliderProps, ...styledProps }: FormikSliderFieldSetProps) => {
  return (
    <Flex {...styledProps}>
      <FormikSlider name={name} mr={20} flex={1} {...sliderProps} />
      <FormikInput name={name} maxLength="3" flex="0 0 56px" {...inputProps} />
    </Flex>
  );
};

export default FormikSliderFieldSet;
